<script setup lang="ts">
defineProps({ blok: Object });

const open = ref(false);
const video = ref<HTMLVideoElement | null>(null);

watch(
  () => open.value,
  async (newVal) => {
    if (newVal) {
      await nextTick();
      video.value?.play();
    } else {
      video.value?.pause();
    }
  },
);
</script>

<template>
  <section v-if="blok" class="section bg-chsc-raw">
    <UiContainer>
      <div class="grid grid-cols-2 gap-x-20">
        <div>
          <header>
            <h3 class="font-londrina-solid text-chsc-indigo-500 fs-7xl">{{ blok.title }}</h3>
          </header>
          <div class="mt-8 global-text text-chsc-indigo-500">
            <StoryblokRichText :doc="blok.text" />
          </div>
          <div class="mt-8">
            <p class="font-londrina-solid fs-5xl text-chsc-yellow">{{ blok.claim }}</p>
          </div>
        </div>
        <div>
          <div v-motion-slide-visible-once-top class="relative rounded-[30px] overflow-hidden">
            <img
              v-if="!open"
              :src="blok.video_cover.filename"
              :alt="blok.video_cover.alt"
              class="w-full h-full object-cover absolute top-0 left-0"
            />
            <div class="w-full h-full">
              <video
                :src="blok.video.filename"
                ref="video"
                class="w-full h-full object-cover"
                controls
                @ended="open = false"
                @pause="open = false"
              ></video>
            </div>
            <button
              v-if="!open"
              class="absolute top-6 left-6 cursor-pointer hover:opacity-60 transition"
              @click="open = true"
            >
              <svg
                width="74"
                height="74"
                viewBox="0 0 74 74"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="37"
                  cy="37"
                  r="35"
                  fill="black"
                  fill-opacity="0.08"
                  stroke="white"
                  stroke-width="4"
                />
                <path
                  d="M30.8253 31.7141C30.8253 30.1745 32.492 29.2123 33.8253 29.9821L46.5753 37.3433C47.9086 38.1131 47.9086 40.0376 46.5753 40.8074L33.8253 48.1686C32.492 48.9384 30.8253 47.9761 30.8253 46.4365L30.8253 31.7141Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
